// extracted by mini-css-extract-plugin
module.exports = {"form":"PoPaymentDetails_form__2_Ef2"};